import { ReactNode } from 'react';
import Button from './Button';
import { TEXT } from './Typography';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export default function EmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}>
      {icon && <div className="mb-4 text-gray-500">{icon}</div>}
      <h3 className={`mb-2 ${TEXT.sectionTitle}`}>{title}</h3>
      {description && <p className={`max-w-md mb-6 ${TEXT.bodyMuted}`}>{description}</p>}
      {action && (
        <Button variant="primary" onClick={action.onClick} className="border-transparent">
          {action.label}
        </Button>
      )}
    </div>
  );
}
